<template>
    <div class="apprentice-simple-card custom-banner-upload">
        <h5 class="title">{{ $t('group.custom_banner') }}</h5>
        <div class="banner-uplaod-info text-muted">
            {{ $t('group.upload_your_own_banner_here_in_jpg_file_type') }}<br />
            {{ $t('group.for_optimal_results_you_should_upload_an_image_of_at_least_1604_x_150_pixels') }}
        </div>

        <div
            class="banner-preview"
            v-if="groupIn.banner">
            <p class="current-custom-banner">{{ $t('group.custom_banner_example') }}</p>
            <b-img
                v-if="groupIn.banner.file.image"
                :src="groupIn.banner.file.image.thumb_path"></b-img>
        </div>

        <div class="banner-upload-actions">
            <b-button
                class="btn-upload btn-upload-banner"
                variant="primary"
                @click="$refs.bannerUpload.$el.childNodes[0].click()">
                {{ $t('group.upload_banner') }}
            </b-button>
            <b-button
                class="btn-restore btn-restore-banner"
                v-if="groupIn.banner"
                variant="danger"
                @click="$bvModal.show('group-show-restore-custom-banner-modal')">
                {{ $t('group.recover_banner') }}
            </b-button>
        </div>
        <b-form-file
            id="assignment-share-banner"
            v-model="file"
            v-show="false"
            accept="image/jpeg"
            :placeholder="'Banner'"
            @change="onFileChange"
            ref="bannerUpload">
        </b-form-file>
        <design-2021-group-show-restore-custom-banner-component
            v-if="groupIn.banner"
            :banner-id-in="groupIn.banner.id"
            :group-in="groupIn">
        </design-2021-group-show-restore-custom-banner-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-custom-banner-component',
    props: {
        groupIn: Object,
    },
    data() {
        return {
            banner: '',
            file: null,
        };
    },
    methods: {
        onFileChange(evt) {
            this.saveBanner(evt.target.files[0]);
        },

        saveBanner(file) {
            if (file === null) {
                return;
            }

            const data = new FormData();
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            data.append('banner', file);

            if (this.groupIn.banner) {
                this.alert.saving();
                axios.post(this.routes.groupBannerUpdate(this.groupIn.id, this.groupIn.banner.id), data, options).then(
                    (response) => {
                        this.alert.success();
                        window.location.href = `${this.routes.groupShow(this.groupIn.id)}`;
                    },
                    (error) => {
                        if (error.response.data.errors && error.response.data.errors.banner) {
                            this.alert.ajaxError(
                                error,
                                this.$t('group.upload_failed'),
                                this.$t('group.check_if_the_banner_is_of_the_file_type_jpg_jpeg'),
                                false,
                            );
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
            } else {
                this.alert.saving();
                axios.post(this.routes.groupBannerCreate(this.groupIn.id), data, options).then(
                    (response) => {
                        this.alert.success();
                        window.location.href = `${this.routes.groupShow(this.groupIn.id)}`;
                    },
                    (error) => {
                        if (error.response.data.errors && error.response.data.errors.banner) {
                            this.alert.ajaxError(
                                error,
                                this.$t('group.upload_failed'),
                                this.$t('group.check_if_the_banner_is_of_the_file_type_jpg_jpeg'),
                                false,
                            );
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
            }
        },
    },
    computed: {
        fileName() {
            if (this.file) {
                return this.$refs.bannerUpload.$el.childNodes[0].files[0].name;
            }
            return '';
        },
    },
};
</script>

<style scoped lang="scss">
.banner-uplaod-info,
.banner-preview {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.banner-preview {
    p {
        font-size: 1rem;
        font-weight: 500;
        margin: 20px 0 8px 0;
    }

    img {
        max-height: 225px;
        width: 100%;
        object-fit: cover;
        object-position: center;
    }
}

.banner-upload-actions {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .btn:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .banner-upload-actions {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .btn:not(:last-child) {
            margin-bottom: 0;
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
}
</style>
